export default __webpack_public_path__ + "static/media/planet_purple.4443847e.png";